import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import DefaultLayout from "../../../../layouts/DefaultLayout";
import { Card, Col, Row } from "antd";
import { forEach, isEmpty } from "lodash";
import WizardForm from "../../../../ui/forms/WizardForm";
import { tabs } from "../../../../../configs/calculator-form/property-tabs";
import VHSpinner from "../../../../ui/VHSpinner";

@inject("context")
@observer
class MtaForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			counter: 0,
		};
	}

	refresh() {
		this.setState({
			...this.state,
			counter: 3,
		});
	}

	componentDidMount() {
		this.loadInsurance();
	}

	render() {
		const service = this.props.context.insuranceMtaService;
		const { insuranceForMta } = service;

		if (insuranceForMta && insuranceForMta.organisation) {
		} else {
			return <VHSpinner />;
		}

		if (isEmpty(insuranceForMta)) {
			return <VHSpinner />;
		}

		return (
			<DefaultLayout>
				<Row>
					<Col xs={24}>
						<Card title={<h1>Activities Insurance - Mid-term adjustment</h1>}>
							<Row>
								<Col xs={24}>
									<p>
										Please fill out the forms in the wizard in order to get
										details about your insurance.
									</p>
								</Col>
							</Row>
							<Row>
								<Col xs={24}>
									<WizardForm
										service={service}
										onFinish={this.onFinish}
										tabs={tabs}
										checkUKTelephone={this.checkUKTelephone}
									/>
								</Col>
							</Row>
						</Card>
					</Col>
				</Row>
			</DefaultLayout>
		);
	}

	onFinish = async ({ startDate, ...values }) => {
		const { policyNumber, quoteId } = this.props.match.params; //
		const service = this.props.context.insuranceMtaService;
		const { isViewMode } = this.props.context.policiesService;
		const { tabsService } = this.props.context;

		forEach(values, (val, key) => service.changeClientData(key, val));

		if (startDate) {
			service.changeClientData("startDate", startDate.toISOString());
		}

		let modeUpdatingQuote = false;
		if (quoteId) {
			modeUpdatingQuote = true;
		}
		if (tabsService.isOnLastFormTab) {
			await service.calculateInsuranceMta(modeUpdatingQuote, isViewMode);
			{
				service.insuranceForMta.policyNumber
					? this.props.history.push(
						`/mta/confirm/policy/${service.insuranceForMta.policyNumber}`
					)
					: this.props.history.push(
						`/mta/confirm/quote/${service.insuranceForMta.quoteId}`
					);
			}
		} else {
			tabsService.goToNextFormTab();
		}
	};

	loadInsurance = async () => {
		const { policyNumber, quoteId } = this.props.match.params;
		const service = this.props.context.insuranceMtaService;

		if (policyNumber) {
			await service.loadInsuranceForMta(policyNumber);
			service.setClientData(service.insuranceForMta);
			setTimeout(() => {
				this.refresh();
			}, 2000);
		}
		if (quoteId) {
			await service.loadInsuranceForMta(quoteId, true);
			service.setClientData(service.insuranceForMta);
			setTimeout(() => {
				this.refresh();
			}, 2000);
		}
	};
	// /////////////////
	checkUKTelephone = (telephoneNumber) => {
		const service = this.props.context.insuranceQuotingService;
		var telNumberErrorNo = 0;
		var telNumberErrors = new Array();
		telNumberErrors[0] = "Valid UK telephone number";
		telNumberErrors[1] = "Telephone number not provided";
		telNumberErrors[2] = "UK telephone number without the country code, please";
		telNumberErrors[3] = "UK telephone numbers should contain 10 or 11 digits";
		telNumberErrors[4] = "The telephone number should start with a 0";
		telNumberErrors[5] =
			"The telephone number is either invalid or inappropriate";
		//Test if undefined
		if (telephoneNumber === "undefined" || !telephoneNumber) {
			telNumberErrorNo = 1;
			// return false;
			service.setPhoneNumberMessage(telNumberErrors[telNumberErrorNo]);
			return { error: true, message: telNumberErrors[telNumberErrorNo] };
		}

		// Convert into a string and check that we were provided with something
		var telnum = telephoneNumber + " ";

		let telnumLength = telnum.length;
		if (telnumLength === 1) {
			telNumberErrorNo = 1;
			// return false;
			service.setPhoneNumberMessage(telNumberErrors[telNumberErrorNo]);
			return { error: true, message: telNumberErrors[telNumberErrorNo] };
		}
		telnumLength = telnumLength - 1;

		// Don't allow country codes to be included (assumes a leading "+")
		var exp = /^(\+)[\s]*(.*)$/;
		if (exp.test(telnum) === true) {
			telNumberErrorNo = 2;
			// return false;
			service.setPhoneNumberMessage(telNumberErrors[telNumberErrorNo]);
			return { error: true, message: telNumberErrors[telNumberErrorNo] };
		}

		// Remove spaces from the telephone number to help validation
		while (telnum.indexOf(" ") !== -1) {
			telnum =
				telnum.slice(0, telnum.indexOf(" ")) +
				telnum.slice(telnum.indexOf(" ") + 1);
		}

		// Remove hyphens from the telephone number to help validation
		while (telnum.indexOf("-") !== -1) {
			telnum =
				telnum.slice(0, telnum.indexOf("-")) +
				telnum.slice(telnum.indexOf("-") + 1);
		}

		// Now check that all the characters are digits
		exp = /^[0-9]{10,11}$/;
		if (exp.test(telnum) !== true) {
			telNumberErrorNo = 3;
			// return false;
			service.setPhoneNumberMessage(telNumberErrors[telNumberErrorNo]);
			return { error: true, message: telNumberErrors[telNumberErrorNo] };
		}

		// Now check that the first digit is 0
		exp = /^0[0-9]{9,10}$/;
		if (exp.test(telnum) !== true) {
			telNumberErrorNo = 4;
			// return false;
			service.setPhoneNumberMessage(telNumberErrors[telNumberErrorNo]);
			return { error: true, message: telNumberErrors[telNumberErrorNo] };
		}

		// Disallow numbers allocated for dramas.

		// Array holds the regular expressions for the drama telephone numbers
		var tnexp = new Array();
		tnexp.push(
			/^(0113|0114|0115|0116|0117|0118|0121|0131|0141|0151|0161)(4960)[0-9]{3}$/
		);
		tnexp.push(/^02079460[0-9]{3}$/);
		tnexp.push(/^01914980[0-9]{3}$/);
		tnexp.push(/^02890180[0-9]{3}$/);
		tnexp.push(/^02920180[0-9]{3}$/);
		tnexp.push(/^01632960[0-9]{3}$/);
		tnexp.push(/^07700900[0-9]{3}$/);
		tnexp.push(/^08081570[0-9]{3}$/);
		tnexp.push(/^09098790[0-9]{3}$/);
		tnexp.push(/^03069990[0-9]{3}$/);

		for (var i = 0; i < tnexp.length; i++) {
			if (tnexp[i].test(telnum)) {
				telNumberErrorNo = 5;
				// return false;
				service.setPhoneNumberMessage(telNumberErrors[telNumberErrorNo]);
				return { error: true, message: telNumberErrors[telNumberErrorNo] };
			}
		}

		// Finally check that the telephone number is appropriate.
		exp = /^(01|02|03|05|070|071|072|073|074|075|07624|077|078|079)[0-9]+$/;
		if (exp.test(telnum) !== true) {
			telNumberErrorNo = 5;
			// return false;
			service.setPhoneNumberMessage(telNumberErrors[telNumberErrorNo]);
			return { error: true, message: telNumberErrors[telNumberErrorNo] };
		}

		// Telephone number seems to be valid - return the stripped telehone number
		// return telnum;
		service.setPhoneNumberMessage(telNumberErrors[telNumberErrorNo]);
		return { error: false, message: telnum };
	};
}

export default MtaForm;
